const mediaData = [
  {
    title: '香蕉视频 · 热门精选',
    desc: '本周播放量最高的10部作品，涵盖动作、剧情、悬疑多种题材',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20cinematic%20abstract%20digital%20art%20with%20coral%20and%20soft%20golden%20gradients%2C%20film%20strip%20inspired%20flowing%20shapes%2C%20modern%20minimalist%20video%20aesthetic%2C%20soft%20ambient%20lighting%20effect%2C%20no%20text%20no%20people&width=800&height=500&seq=media-1-2026&orientation=landscape',
    tag: '热门',
    duration: '120+部作品',
  },
  {
    title: '红桃视频 · 原创首发',
    desc: '独家原创系列作品持续更新，品质内容不容错过',
    image: 'https://readdy.ai/api/search-image?query=An%20elegant%20abstract%20digital%20composition%20with%20warm%20rose%20and%20amber%20tones%2C%20layered%20geometric%20shapes%20evoking%20cinematography%20and%20original%20creation%2C%20refined%20gradient%20depth%2C%20contemporary%20design%2C%20no%20text%20no%20people&width=800&height=500&seq=media-2-2026&orientation=landscape',
    tag: '原创',
    duration: '42个系列',
  },
  {
    title: '91视频 · 社区精选',
    desc: '高评分社区推荐内容，真实用户口碑背书',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20abstract%20illustration%20with%20warm%20terracotta%20and%20cream%20gradients%2C%20interconnected%20circular%20design%20elements%20representing%20community%20engagement%2C%20soft%20lighting%20aesthetic%2C%20minimalist%20composition%2C%20no%20text%20no%20people&width=800&height=500&seq=media-3-2026&orientation=landscape',
    tag: '社区',
    duration: '86部精选',
  },
  {
    title: '蜜桃视频 · 高清体验',
    desc: '4K超清画质专区，极致流畅不缓冲播放技术展示',
    image: 'https://readdy.ai/api/search-image?query=A%20clean%20abstract%20digital%20artwork%20with%20soft%20peach%20and%20golden%20gradients%2C%20smooth%20flowing%20lines%20representing%20high%20definition%20streaming%2C%20crystal%20clear%20aesthetic%2C%20contemporary%20minimalist%20design%2C%20no%20text%20no%20people&width=800&height=500&seq=media-4-2026&orientation=landscape',
    tag: '4K',
    duration: '50+部高清',
  },
];

export default function Media() {
  return (
    <section id="media" className="bg-background-50 section-padding">
      <div className="section-container">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            精彩推荐
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精彩推荐
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            各平台精选内容展示，发现热门原创与高品质影视作品
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {mediaData.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video bg-background-100 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className={`inline-block px-2 py-0.5 rounded-full text-[10px] font-medium ${
                    item.tag === '热门' ? 'bg-primary-500 text-background-50' :
                    item.tag === '原创' ? 'bg-accent-500 text-background-50' :
                    item.tag === '4K' ? 'bg-primary-500 text-background-50' :
                    'bg-secondary-500 text-background-50'
                  }`}>
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-12 h-12 rounded-full bg-background-950/60 flex items-center justify-center">
                    <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-800 mb-1.5 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-2 line-clamp-2">
                  {item.desc}
                </p>
                <div className="flex items-center gap-1.5 text-xs text-foreground-400">
                  <i className="ri-film-line"></i>
                  <span>{item.duration}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}